export default __webpack_public_path__ + "static/media/partner-2-axie.1edc2632.png";